import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Table, notification, DatePicker, Select, Button, Alert } from 'antd';
import { DownloadOutlined, FilePdfOutlined, MailOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import dayjs from 'dayjs';
import { AuthContext } from 'context/AuthContext';
import reportService from 'services/report.service';
import download from 'js-file-download';
import { formatMoney } from 'helpers/utils';
import 'antd/dist/reset.css';

const { MonthPicker } = DatePicker;
const { Option } = Select;

const monthFormat = 'YYYY/M';

const withRouter = (WrappedComponent) => {
  return (props) => {
    const navigate = useNavigate();
    return <WrappedComponent {...props} navigate={navigate} />;
  };
};

class Babs extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      reports: [],
      nullNotification:
        'İlgili döneme ait BA/BS raporu bulunmamaktadır.İlgili döneme ait raporunuz var ise müşteri hizmetleri ile iletişime geçiniz',
      nullNotificationInfo: 'lütfen ilgili rapor türü ve tarih bilgisini seçiniz.',
      loading: false,
      downloading: false,
      mailLoading: false,
      pdfLoading: false,
      type: 'BABS',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      currentMerch: context?.selectedMerch,
      columns: [
        {
          title: <div className="table-title-calibri-bold-12">BA/BS</div>,
          dataIndex: 'Type',
          key: 'Type',
          align: 'center',
          render: (text, row) => {
            return <span className="table-title-calibri-bold-12">{row.Type ? row.Type : ' '}</span>;
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">Ad Soyad veya Ünvan</div>,
          dataIndex: 'Name',
          key: 'Name',
          align: 'center',
          render: (text, row) => {
            return <span className="table-title-calibri-bold-12">{row.Name ? row.Name : ' '}</span>;
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">Vergi No</div>,
          dataIndex: 'TaxNo',
          key: 'TaxNo',
          align: 'center',
          render: (text, row) => {
            return (
              <span className="table-title-calibri-bold-12">{row.TaxNo ? row.TaxNo : ' '}</span>
            );
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">TCKN</div>,
          dataIndex: 'Tckn',
          key: 'Tckn',
          align: 'center',
          render: (text, row) => {
            return <span className="table-title-calibri-bold-12">{row.Tckn ? row.Tckn : ' '}</span>;
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">Döküman Sayısı</div>,
          dataIndex: 'DocumentCount',
          key: 'DocumentCount',
          align: 'center',
          render: (text, row) => {
            return (
              <div className="text-align-center">
                <span className="table-title-calibri-bold-12">
                  {row.DocumentCount ? row.DocumentCount : ' '}
                </span>
              </div>
            );
          },
        },
        {
          title: (
            <div className="table-title-calibri-bold-12">
              Mal ve Hizmetlerin Toplam Bedeli (KDV Hariç)
            </div>
          ),
          dataIndex: 'TotalAmountWithoutKDV',
          key: 'TotalAmountWithoutKDV',
          align: 'center',
          render: (text) => (
            <div className="text-align-center">
              <span className="table-title-calibri-bold-12">{`${formatMoney(text)} TL`}</span>,
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">İşlemler</div>,
          dataIndex: 'FaturaURL',
          key: 'FaturaURL',
          align: 'center',
          width: 120,
          render: (item, data) => (
            <Button
              key="1"
              loading={this.state.mailLoading === data.TaxNo}
              type="primary"
              icon={<FilePdfOutlined />}
              onClick={() => this.downloadSelectedPDF(data)}
            >
              İndir
            </Button>
          ),
        },
        {
          dataIndex: 'sendMail',
          key: 'sendMail',
          width: 50,
          render: (item, data) => (
            <Button
              key="1"
              loading={this.state.mailLoading === data.TaxNo}
              type="primary"
              icon={<MailOutlined />}
              onClick={() => this.sendSelectedMail(data)}
            >
              Mail
            </Button>
          ),
        },
      ],
    };
    this.getReports = this.getReports.bind(this);
  }

  componentDidMount() {
    this.getReports();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.currentMerch?.number !== this.context?.selectedMerch?.number &&
      this.state?.currentMerch?.number === prevState.currentMerch?.number
    ) {
      this.getReports();
    }
  }

  sendSelectedMail = (data) => {
    this.setState({ mailLoading: data.TaxNo });
    const body = {
      baBsResource: {
        Type: data.Type,
        Name: data.Name,
        TaxNo: data.TaxNo,
        Tckn: data.Tckn,
        DocumentCount: parseFloat(data.DocumentCount),
        TotalAmountWithoutKDV: data.TotalAmountWithoutKDV,
      },
      mailInformation: {
        to: this.context?.currentUser?.email,
        subject: 'BA-BS Raporu',
        text: 'BA-BS Rapor Formatı Ektedir.',
      },
    };

    reportService
      .sentMailBABS(body)
      .then(() => {
        notification.success({
          message: 'İşlem Başarılı',
          description: 'Mailinizi kontrol ediniz.',
        });
        this.setState({ mailLoading: false });
      })
      .catch((error) => {
        this.setState({ mailLoading: false });
        notification.error({
          message: 'İşlem Başarısız',
          description: error,
        });
      });
  };

  getReports = () => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      try {
        const { currentMerch, year, month, type } = this.state;
        if (currentMerch?.number) {
          const { payload } = await reportService.getBabsReports(
            currentMerch?.number,
            year,
            month,
            type,
          );
          this.setState({ loading: false, reports: payload });
        } else {
          // this.setState({nullNotification:'İlgili döneme ait BA/BS raporu bulunmamaktadır.İlgili döneme ait raporunuz var ise müşteri hizmetleri ile iletişime geçiniz' })
        }
      } catch (error) {
        this.setState({ loading: false, reports: [] });
        notification.error({
          message: 'İşlem Başarısız',
          description: error,
        });
      }
    });
  };

  downloadPDF = async () => {
    try {
      this.setState({ downloading: true });
      const { currentMerch, year, month, type } = this.state;
      const data = await reportService.getBabsReportsPdf(currentMerch?.number, year, month, type);
      download(data, `BABS-${currentMerch?.number}-${dayjs().format('DD-MM-YYYY')}.pdf`);
      this.setState({ downloading: false });
    } catch (error) {
      this.setState({ loading: false, downloading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error,
      });
    }
  };

  downloadSelectedPDF = async (data) => {
    try {
      this.setState({ pdfLoading: data.TaxNo });
      const { currentMerch } = this.state;
      const body = {
        baBsResource: {
          Type: data?.Type,
          Name: data?.Name,
          TaxNo: data?.TaxNo,
          Tckn: data?.Tckn,
          DocumentCount: parseFloat(data?.DocumentCount),
          TotalAmountWithoutKDV: data?.TotalAmountWithoutKDV,
        },
      };
      const payload = await reportService.getBabsReportsSelectedPdf(body);
      download(payload, `BABS-${currentMerch?.number}-${dayjs().format('DD-MM-YYYY')}.pdf`);
      this.setState({ pdfLoading: false });
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Pdf İndirildi.',
      });
    } catch (error) {
      this.setState({ pdfLoading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error,
      });
    }
  };

  onDateChange = (date, value) => {
    const [year, month] = value.split('/');
    this.setState({ year, month }, () => {
      this.getReports();
    });
  };

  onTypeChange = (type) => {
    this.setState({ type }, () => {
      this.getReports();
    });
  };

  render() {
    const { reports, columns, loading, downloading, year, month } = this.state;
    const { navigate } = this.props;
    return (
      <PageContainer
        onBack={() => navigate(-1)}
        title="BA-BS Raporu"
        extra={[
          <Select
            key="type-select"
            defaultValue="BABS"
            style={{ width: 120, marginRight: 15 }}
            onChange={this.onTypeChange}
          >
            <Option value="BA">BA</Option>
            <Option value="BS">BS</Option>
            <Option value="BABS">BA-BS</Option>
          </Select>,
          <MonthPicker
            key="babs"
            allowClear={false}
            defaultValue={dayjs(`${year}/${month}`, monthFormat)}
            format={monthFormat}
            onChange={this.onDateChange}
          />,
          <Button
            loading={downloading}
            disabled={loading || downloading}
            key="download"
            type="primary"
            icon={<DownloadOutlined />}
            onClick={async () => {
              await this.downloadPDF();
            }}
          >
            İndir
          </Button>,
        ]}
      >
        {!loading && (
          <div>
            {reports && reports.length > 0 ? (
              <>
                <Alert
                  style={{ marginBottom: 15 }}
                  message="Seçilen tarih aralığındaki BA/BS hesap rapor sonuçları aşağıdaki gibidir."
                  type="info"
                  showIcon
                />

                <Table
                  loading={loading}
                  dataSource={reports}
                  columns={columns}
                  pagination={false}
                  rowKey={(record, index) => index}
                />
              </>
            ) : (
              <>
                <Alert
                  style={{ marginBottom: 15 }}
                  message="İlgili döneme ait BA/BS raporu bulunmamaktadır.İlgili döneme ait raporunuz var ise müşteri hizmetleri ile iletişime geçiniz."
                  type="warning"
                  showIcon
                />
                <Alert
                  style={{ marginBottom: 15 }}
                  message="Lütfen ilgili RAPOR TÜRÜ ve TARİH bilgisini seçiniz."
                  type="warning"
                  showIcon
                />
              </>
            )}
          </div>
        )}
      </PageContainer>
    );
  }
}

Babs.contextType = AuthContext;

Babs.propTypes = {
  navigate: PropTypes.func.isRequired,
};

export default withRouter(Babs);
